<template>
	<div class="management">
		<!--模拟框修改密码-->
		<!--弹出框-->
		<el-dialog 
			title="修改密码" 
			:visible.sync="dialogVisible" 
			width="375px" 
			:close="handleClose" 
			top="25vh">
			<div class="dialogMain">
				<dl>
					<dt>&emsp;原密码：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.oPwd" class="inputWidth" :placeholder="oPwd"></el-input>
					</dd>
				</dl>				
				<dl>
					<dt>&emsp;新密码：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.pwd" type="password" class="inputWidth" :placeholder="pwd"></el-input>
					</dd>
				</dl>				
				<dl>
					<dt>确认密码：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.verifyPwd" type="password" class="inputWidth" :placeholder="verifyPwd"></el-input>
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()">确 定</el-button>
		  </span>
		</el-dialog>
		<!--模拟框结束-->
		<a class="title" href="javascript:void(0)" @click="toggle()">
			<i class="el-icon-setting"></i><span> 系统管理</span>
		</a>
		<div class="select-items" v-show="show">
			<ul>
				<li>你好！{{usrName}}</li>
				<li @click="dialogShow()">修改密码</li>
				<li @click="exit()">注销</li>
			</ul>
		</div>
		<i class="arrow" v-show="show"></i>		
	</div>	
</template>

<script>
	export default{
		data(){
			return{
				oPwd:'原密码',
				pwd:'请输入6~16位密码',
				verifyPwd:'确认密码',
				usrName:'',
				dialogData: {
					oPwd:'',
					pwd:'',
					verifyPwd:'',
				},
				dialogVisible: false,
				show: false
			}
		},
		methods: {
			handleClose: function(done) {
				done();
			},
			toggle: function(){
				this.show = !this.show
			},
			dialogShow: function(){
				this.show = false
				this.dialogVisible = true
			},
			handleConfirm: function(){
				this.oPwd='原密码',
				this.pwd='请输入6~16位密码',
				this.verifyPwd='确认密码',
				console.log(this.dialogData)
				if(this.dialogData.verifyPwd==this.dialogData.pwd&&this.dialogData.pwd.trim()!=''&&this.dialogData.oPwd.trim()!=''){
					if(this.pwdlength(this.dialogData.pwd)){
						this.$http.post("zcvrVideoApi/admin/modifyPassowrd/"+sessionStorage.getItem("sessionId"),{
				  			usr: this.usrName,
							oldPwd: this.dialogData.oPwd.trim(),
							newPwd: this.dialogData.verifyPwd.trim()
				  		},{emulateJson:true}).then(
				  			(loginData)=>{
				  				console.log(loginData)
						  		if(loginData.data.msg=="该SessionId已经超时"){
						  			this.$message.error("登录超时！请重新登录");
				  					this.dialogVisible = false
						  			this.$router.push({path: '/',query: ''})
						  		}
				  				if(loginData.body.status==200){				  					
							        this.$message({
							          message: '密码修改成功',
							          type: 'success'
							        });
				  					sessionStorage.setItem("sessionId",'')
				  					this.dialogVisible = false
									this.$router.push({path: '/',query: ''})	  					
				  				}else{
  									this.dialogData={}  
									this.$message.error(loginData.body.msg);
			  					}
				  			},
				  			(error)=>{
				  				console.log("数据连接失败")
				  			}
				  		)

					}else{
						this.$message.error("新密码请输入6~16位的密码");
  						this.dialogData.verifyPwd = ""
  						this.dialogData.pwd = ""
						this.pwd = "请输入6~16位密码"
					}
				}else{
					if(this.dialogData.verifyPwd!=this.dialogData.pwd){
						this.dialogData.verifyPwd = ''
						this.verifyPwd = '与新密码不符'
					}
					if(this.dialogData.pwd==''){
						this.pwd = '不能为空'
					}
					if(this.dialogData.oPwd==''){
						this.dialogData.oPwd = ''
						this.oPwd = '不能为空'
					}
				}
				
				
			},
			//密码正则表达式密码长度(6-16)
		    pwdlength: function(val) {
		    	return /^[A-Za-z0-9]{6,16}$/.test(val)
		    },
			exit: function(){
				sessionStorage.setItem("sessionId",'')
				this.$router.push({path: '/',query: ''})
			}
		},
		mounted: function(){
			this.usrName = sessionStorage.getItem("usrName")
		}
	}
</script>

<style>
	.dialogMain dl dt {
	    display: block;
	    float: left;
	    color: #6d7e86;
	    font-weight: 400;
	    line-height: 32px;
	    margin-right: 10px;
	}
	.dialogMain dl dd {
		display: block;
	    overflow: hidden;
	}
	.dialogMain dl dt,.dialogMain dl dd{
		line-height: 40px;
	}
	.inputWidth{
		width: 230px;
	}
	a.title{
		line-height: 20px;
		color: #686f7f;
		text-decoration: none;
	}
	.management {
	    display: inline-block;
	    vertical-align: middle;
	    position: absolute;
	    top: 20px;
		right: 20px;
	}
	.management .select-items{
		z-index: 100;
		position: absolute;
	    right: 0;
	    top: 34px;
	}
	.management .select-items ul{
	    position: relative;
		padding: 5px;
		margin: 0;
		max-height: 280px;
		border: 1px solid #eee;
		background: #fff;
		overflow-y: auto;
		overflow-x: hidden;
		list-style: none;
	}
	.management .select-items ul li{
	    display: block;
	    padding: 4px 10px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666;
	    white-space: nowrap;
	    cursor: pointer;
	}
	.management .arrow{
    	position: absolute;
		right: 13px;
		top: 30px;
		width: 10px;
		height: 10px;
		background: #fff;
		transform:rotate(45deg);
		z-index: 100;
	}
</style>